import axios from 'axios';
import { getBaseUrl } from '../../environment/utility';
import { baseUrl, HttpMethods } from '../base';
import type {
  IGetNotificationPreferencesServiceRes,
  IGetNotificationsService,
  IGetNotificationsServiceRes,
  IPostReadAllNotificationService,
  IPostReadNotificationService,
  IPutNotificationPreferencesService,
} from './types';

const notificationBasePath = `${baseUrl.SHERPA}/notifications`;
const sagensBasePath = `${getBaseUrl('notification')}/api/notifications`;

export async function getNotificationPreferences(): Promise<IGetNotificationPreferencesServiceRes> {
  const resp = await axios.request<IGetNotificationPreferencesServiceRes>({
    method: HttpMethods.GET,
    url: notificationBasePath,
  });
  return resp.data;
}

export async function putNotificationPreferences({ data }: IPutNotificationPreferencesService) {
  const res = await axios.request({
    method: HttpMethods.PUT,
    url: notificationBasePath,
    data,
  });
  return res.data;
}

export async function putNotificationPreferencesDefault() {
  const res = await axios.request({
    method: HttpMethods.PUT,
    url: `${notificationBasePath}/set_to_default`,
  });
  return res.data;
}

export async function getNotifications({ params }: IGetNotificationsService): Promise<IGetNotificationsServiceRes> {
  const res = await axios.request({
    withCredentials: false,
    method: HttpMethods.GET,
    url: sagensBasePath,
    params,
  });
  return res.data;
}

export async function postReadNotification({ notificationId }: IPostReadNotificationService) {
  const res = await axios.request({
    withCredentials: false,
    method: HttpMethods.POST,
    url: `${sagensBasePath}/${notificationId}/read`,
  });
  return res.data;
}

export async function postReadAllNotifications({ data }: IPostReadAllNotificationService) {
  const res = await axios.request({
    withCredentials: false,
    method: HttpMethods.POST,
    url: `${sagensBasePath}/read_all`,
    data,
  });
  return res.data;
}
